import { ExportStatus, ExportType } from "@prisma/client-generated";
import z from "zod";

export { ExportStatus, ExportType };

export const zExportType = z.nativeEnum(ExportType);
export const zExportStatus = z.nativeEnum(ExportStatus);

export const zExport = z.object({
	id: z.string(),
	status: zExportStatus,
	resultFileKey: z.string(),
	type: zExportType,
	downloadUrl: z.string().nullish(),
});

export type Export = z.infer<typeof zExport>;
